import React, {useState} from 'react';
import {
  getAuth,
  OAuthProvider,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
} from 'firebase/auth';
import {useAuthState} from '../../../shared/services/firebase';
import {Button, Col, Row} from 'react-bootstrap';
import {Route} from 'react-router-dom';
import Envelope from '@mui/icons-material/EmailRounded';
import InfoCircle from '@mui/icons-material/InfoRounded';
import Lock from '@mui/icons-material/LockRounded';
import {CardSkeleton} from '../../../shared/ui/LoadingSkeletons';

const provider = new OAuthProvider('microsoft.com');

const AuthenticatedRoute = ({component: C, ...props}) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [passwordSent, setPasswordSent] = useState();

  const authState = useAuthState();
  const auth = getAuth();

  const signInWithM365 = () => {
    setLoading(true);
    signInWithPopup(auth, provider)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
    setLoading(false);
  };

  const signInWithEmail = (event) => {
    event.preventDefault();
    setLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then(() => {})
      .catch((error) => {
        setError(error);
      });
    setLoading(false);
  };

  const passwordReset = () => {
    setLoading(false);
    sendPasswordResetEmail(auth, email)
      .then(() => {
        setPasswordSent('Link für Password Reset wurde per E-Mail gesendet!');
      })
      .catch((error) => {
        setError(error);
      });
    setLoading(false);
  };

  let routeContent;

  if (authState.user === undefined) {
    routeContent = (
      <>
        <Col style={{width: '49%'}} className="d-flex align-items-center">
          <div
            style={{flex: 1, width: '25%', height: '38px', background: '#e0e0e0', borderRadius: '4px'}}
            className="me-2"
          />
          <div style={{width: '120px', height: '38px', background: '#e0e0e0', borderRadius: '4px'}} />
        </Col>
        <Row xs={1} md={2}>
          <CardSkeleton count={10} />
        </Row>
      </>
    );
  } else if (authState.user === null) {
    routeContent = (
      <>
        <div className="Auth-form-container">
          <form className="Auth-form" onSubmit={signInWithEmail}>
            <div className="Auth-form-content">
              <div className="d-flex align-items-center gap-2 mb-2">
                <h1 className="mb-0">Anmelden</h1>
                <a
                  href="https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Zugriff-%26-Anmeldung"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InfoCircle size={20} />
                </a>
              </div>
              <p>mit E-Mail-Adresse und Password</p>
              <br />
              <div className="form-group mt-3">
                <p><Envelope /> E-Mail</p>
                <input
                  type="email"
                  className="form-control mt-1"
                  placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
              <div className="form-group mt-3">
                <p><Lock /> Passwort</p>
                <input
                  type="password"
                  className="form-control mt-1"
                  placeholder="Geben Sie Ihr Passwort ein"
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>
              <p className="forgot-password">
                <a onClick={passwordReset}>Passwort vergessen?</a>
              </p>
              <div className="d-grid gap-2 mt-3">
                <button type="submit" className="btn btn-primary">Anmelden</button>
              </div>
            </div>
            {error && <p style={{color: 'red'}}><br />{error.code} {error.message}</p>}
            {passwordSent && <p><br />{passwordSent}</p>}
            <br />
            <div className="Auth-form-content text-center">
              <p>oder</p>
              <Button variant="link" onClick={signInWithM365}>
                <img src="/ms-symbollockup_signin_dark.svg" alt="Sign in with Microsoft" />
              </Button>
              <p style={{marginTop: '200px'}} className="kein-konto">
                Kein Konto? <br /> <a href="/signup">Jetzt registrieren</a>
              </p>
            </div>
          </form>
        </div>
        <br />
      </>
    );
  } else {
    routeContent = <C {...props} />;
  }

  return (
    <Route
      {...props}
      render={() => routeContent}
    />
  );
};

export {AuthenticatedRoute};
